const DAY = 86400000
const MSK = 3 * 3600000

export const workshopTimestamp = value => {
    if (!value) return null
    const text = String(value).replace(' ', 'T')
    const date = new Date(/(?:Z|[+-]\d\d(?::?\d\d)?)$/i.test(text) ? text : `${text}Z`)
    return Number.isFinite(date.getTime()) ? date : null
}
export const workshopOrderDate = order => workshopTimestamp(order.period_at || order.completed_at || order.approved_at || order.created_at)
const dayOf = date => new Date(date.getTime() + MSK).toISOString().slice(0, 10)
const midnight = day => Date.parse(`${day}T00:00:00+03:00`)
const shift = (day, days) => new Date(Date.parse(`${day}T00:00:00Z`) + days * DAY).toISOString().slice(0, 10)

export function workshopPeriodDates(period, from = '', to = '', now = new Date()) {
    const today = dayOf(now)
    if (period === 'today') return { from: today, to: today }
    if (period === 'week') return { from: shift(today, -6), to: today }
    if (period === 'month') {
        const previous = new Date(`${today}T00:00:00Z`), day = previous.getUTCDate()
        previous.setUTCDate(1)
        previous.setUTCMonth(previous.getUTCMonth() - 1)
        previous.setUTCDate(Math.min(day, new Date(Date.UTC(previous.getUTCFullYear(), previous.getUTCMonth() + 1, 0)).getUTCDate()))
        return { from: previous.toISOString().slice(0, 10), to: today }
    }
    return { from, to }
}

export function buildWorkshopIntervals({ period, from = '', to = '', orders = [], now = new Date() }) {
    const dates = workshopPeriodDates(period, from, to, now)
    const available = orders.map(workshopOrderDate).filter(Boolean).map(dayOf).sort()
    const first = dates.from || available[0] || dates.to
    const last = dates.to || available.at(-1) || dates.from
    if (!first || !last || first > last) return []
    const start = midnight(first), end = midnight(shift(last, 1))
    if (!Number.isFinite(start) || !Number.isFinite(end)) return []
    const days = Math.round((end - start) / DAY)
    const step = days === 1 ? 3 * 3600000 : days <= 8 ? DAY : days <= 15 ? 2 * DAY : days <= 60 ? 7 * DAY : null
    const groupBy = days === 1 ? 'three_hours' : days <= 8 ? 'day' : days <= 15 ? 'two_days' : days <= 60 ? 'seven_days' : 'month'
    const format = (value, options) => new Date(value).toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow', ...options })
    const intervals = []
    for (let at = start; at < end;) {
        const local = new Date(at + MSK)
        const next = step == null ? Date.UTC(local.getUTCFullYear(), local.getUTCMonth() + 1, 1) - MSK : at + step
        const until = Math.min(next, end)
        let label
        if (groupBy === 'three_hours') label = `${String(local.getUTCHours()).padStart(2, '0')}:00`
        else if (groupBy === 'month') label = format(at, { month: 'short', ...(first.slice(0, 4) !== last.slice(0, 4) ? { year: 'numeric' } : {}) })
        else if (step === DAY || until - at <= DAY) label = format(at, { day: '2-digit', month: '2-digit' })
        else label = `${format(at, { day: '2-digit', month: '2-digit' })}–${format(until - 1, { day: '2-digit', month: '2-digit' })}`
        const full = value => new Date(value).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        intervals.push({ date: new Date(at).toISOString(), start: at, end: until, label, tooltip: `${full(at)} — ${full(until - 1)} МСК`, groupBy })
        at = until
    }
    return intervals
}

export function findWorkshopInterval(intervals, date) {
    if (!date) return -1
    const value = date.getTime()
    let left = 0, right = intervals.length - 1
    while (left <= right) {
        const mid = Math.floor((left + right) / 2), interval = intervals[mid]
        if (value < interval.start) right = mid - 1
        else if (value >= interval.end) left = mid + 1
        else return mid
    }
    return -1
}

export const workshopBarHeight = (count, maximum) => count > 0 && maximum > 0 ? Math.max(4, count / maximum * 70) : 4
